import * as snack from './services/snack';

import recover from './services/recover';

document.querySelector('#recover').addEventListener('click', () => {
  const input = document.querySelector('#login');
  if (!input.value) {
    input.focus();
    return snack.error('missing-user');
  }

  return recover(input.value)
    .then(({data : email}) => snack.success('email-sent', email))
    .catch(({ message }) => snack.error(message));
});
